import {request} from "@/network/request";
//seed详情
export function getSeedsInfo(id) {
  return request({
    url: '/gaoligong/seednew/' + id,
    method: 'get'
  })
}
//dna
export function getDnaInfo(id) {
  return request({
    url: '/gaoligong/dna/' + id,
    method: 'get'
  })
}
//getdriedLeafInfo
export function getDriedLeafInfo(id) {
  return request({
    url: '/gaoligong/dryblade/' + id,
    method: 'get'
  })
}
//animalgermplasm
export function getAnimalgermplasm(id) {
  return request({
    url: '/gaoligong/animalgermplasmnew/' + id,
    method: 'get'
  })
}
//spineAnimal
export function getSpineAnimal(id) {
  return request({
    url: '/gaoligong/dnabarzoo/' + id,
    method: 'get'
  })
}
//getVascularPlant
export function getVascularPlant(id) {
  return request({
    url: '/gaoligong/dnabarplant/' + id,
    method: 'get'
  })
}
//野生植物名录
export function getWildPlant(id) {
  return request({
    url: '/gaoligong/riskplantdirectory/' + id,
    method: 'get'
  })
}
//特有植物名录
// export function getEndemicPlant(id) {
//   return request({
//     url: '/gaoligong/endemicPlant/' + id,
//     method: 'get'
//   })
// }
//新版本特有植物名录

export function getEndemicPlant(id) {
  return request({
    url: '/gaoligong/specificplantdirectory/' + id,
    method: 'get'
  })
}
